if (!customElements.get('complete-ring-actions')) {
  window.CompleteRingActions = class CompleteRingActions extends HTMLElement {
    constructor() {
      super();
      this.submitBtn = this.querySelector('button');
      this.modal = document.getElementById('miss-match-popup');
      this.cartData = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.popupInstance = new ccPopup($('#miss-match-popup'), '#journey-tracker');

      this.attachEventListeners();
    }

    connectedCallback() {
      this.handleRingMissmatch();
    }

    async handleRingMissmatch() {
      if (window.journey_start_with == 'diamond') {
        const cartAttributes = JSON.parse(document.getElementById('cart-attributes-json').textContent);
        let ringShape = DiamondActions.toHandle(cartAttributes.ring_shape);
        let diamondShape = DiamondActions.toHandle(cartAttributes.diamond_shape);
        if (ringShape !== diamondShape) {
          const attributes = DiamondActions.validateAndUpdateRingShape(cartAttributes);
          let ringShape = DiamondActions.toHandle(attributes.ring_shape);
          let diamondShape = DiamondActions.toHandle(attributes.diamond_shape);
          // if we succefully updated shape then update cart attributes, if not let's leave it as it
          if (ringShape == diamondShape) {
            // show overloay
            DiamondActions.showOverlay();
            await DiamondActions.updateCartAttrs({ attributes });
            // reload
            window.location.reload();
          }
        }
      }
    }

    attachEventListeners() {
      const modalCloseButton = document.querySelector('#miss-match-popup .cc-popup-close');
      const goBackButton = document.querySelector('#miss-match-popup [data-go-back]');
      const proceedAnywayButton = document.querySelector('#miss-match-popup [data-proceed-anyway]');
      this.submitBtn.addEventListener('click', (evt) => {
        if (this.submitBtn.hasAttribute('data-miss-match-modal-trigger')) {
          this.popupInstance.open();
          return;
        }
        this.submit.bind(this)(evt);
      });

      goBackButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        window.location.href = goBackButton.dataset.diamondHref;
      });
      if (proceedAnywayButton)proceedAnywayButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.popupInstance.close();
        this.submit.bind(this)();
      });

      modalCloseButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.popupInstance.close();
      });

      // Add pageshow event listener to handle page load from cache
      window.addEventListener('pageshow', this.handlePageShow.bind(this));
    }

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    async submit() {
      if (window.__diamondUnavailable) {
        // diamond-availability.js found the stone is no longer at Nivoda; never add it to the cart.
        console.warn('Diamond no longer available; add to cart blocked');
        return;
      }
      try {
        DiamondActions.showOverlay({ msg: 'Adding to cart ...' });
        this.submitBtn.setAttribute('disabled', 'disabled');
        const form = this.closest('.product-form');
        //const emtpyCart = await fetch(`${theme.routes.cart_update_url}}/clear.js`);
        const journyItems = this.cartData.items.filter((item) => item.properties._bundle_id).map((item) => item.key);
        const fingerSize = form.querySelector(`.cc-select__option[aria-selected="true"]`)?.dataset?.value || this.cartData?.attributes?.ring?.['Finger size'] || '';
        const bundleId = new Date().getTime();
        const diamondVariantId = this.dataset.diamondVariantId;
        const formData = {
          items: [
            {
              id: this.cartData.attributes.ring_variant_id,
              quantity: 1,
              properties: {
                _bundle_id: bundleId,
                'Finger size': fingerSize,
              },
            },
            {
              id: diamondVariantId,
              quantity: 1,
              properties: {
                _diamond_title: window.diamond_title,
                _bundle_id: bundleId,
                Carats: `${this.dataset.carats}ct`,
                Shape: this.dataset.shape,
                Color: this.dataset.color,
                Clarity: this.dataset.clarity,
                Cut: this.dataset.cut,
                'Certificate ID': this.dataset.certificateId,
              },
            },
          ],
          attributes: {
            //ring: '',
            //diamond: ''
          },
        };
        //await this.clearPrevItems(journyItems);
        const cart = await this.addCartItems(formData);
        console.log('cart', cart);
        //debugger;
        window.location.href = theme.routes.cart_url;
      } catch (error) {
        console.error('error', error);
        //alert('Something went wrong, please try again ', error.message);
        //window.location.reload();
      }
    }

    async addCartItems(data) {
      return fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then((response) => response.json());
    }

    async clearPrevItems(journyItems) {
      if (journyItems.length == 0) return;
      const formData = {
        updates: journyItems.map((item) => {
          return {
            [item.key]: 0,
          };
        }),
      };
    }

    static async updateCartAttrs({ attributes }) {
      return fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        body: JSON.stringify({
          attributes,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then((response) => response.json());
    }

    static async getCart() {
      return await fetch(`${theme.routes.cart_url}.js`).then((response) => response.json());
    }

    static showOverlay({ msg = 'Preparing your diamond ...' } = {}) {
      const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
      const msgEl = overlay.querySelector('.prepparing-diamonds__msg');
      if (msgEl) {
        msgEl.textContent = msg;
      }
      if (overlay) {
        overlay.style.display = 'block';
      }
    }

    disconnectedCallback() {
      this.hideOverlay();
    }
    hideOverlay() {
      // let's hide the overlay
      // and revert the submit button
      const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
      const msgEl = overlay.querySelector('.prepparing-diamonds__msg');
      if (msgEl) {
        msgEl.textContent = '';
      }
      if (overlay) {
        overlay.style.display = 'none';
      }
      //this.submitBtn.removeAttribute('disabled');
    }

    // Handle page load from cache (bfcache)
    handlePageShow(event) {
      // Check if the page was loaded from the browser cache (bfcache)
      if (event.persisted) {
        this.hideOverlay();
      }
    }
  };

  window.customElements.define('complete-ring-actions', CompleteRingActions);
}
